import React, { useState, useEffect, useContext } from 'react';
// import { useRef } from 'react';
import styled from 'styled-components';
import { AiOutlineDownload, AiOutlineEye, AiOutlineClose } from 'react-icons/ai';
import { Typography } from "@mui/material";
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import PocketBase from "pocketbase";
import Slider from "react-slick";

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

const NotesPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [notes, setNotes] = useState([]);
  const [previewUrl, setPreviewUrl] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();
  // const pocketbaseAuthRef = useRef(null);
  const [slides, setSlides] = useState([]);
  const [, setCurrentSlide] = useState(0);
  

  useEffect(() => {
    // if (!auth.isAuthenticated) {
    //   navigate("/login");
    //   return;
    // }


    // if (!pocketbaseAuthRef.current) {
    //   const storedAuth = localStorage.getItem("pocketbase_auth");
    //   pocketbaseAuthRef.current = storedAuth ? JSON.parse(storedAuth).record : null;
    // }

    // const userRole = pocketbaseAuthRef.current?.role || "";

    // if (userRole !== "notes" && userRole !== "full") {
    //   setError("Unauthorized");
    //   setIsLoading(false);
    //   return;
    // }

    const fetchNotes = async () => {
      try {
        setIsLoading(true);
        const responseData = await pb.collection("Notes").getFullList({ sort: "created" });
        if (Array.isArray(responseData)) {
          setNotes(responseData);
        } else {
          throw new Error("Unexpected data format from API");
        }
      } catch (error) {
        console.error("Error fetching notes:", error);
        setError("Failed to load notes. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    const fetchSlides = async () => {
      try {
        const records = await pb.collection("Notes_Slides").getFullList();
        setSlides(records);
      } catch (error) {
        console.error("Error fetching mobile slides:", error);
      }
    };


    fetchSlides();
    fetchNotes();
  }, [auth.isAuthenticated, navigate]);

  // if (!auth.isAuthenticated) {
  //   return null;
  // }

  const filteredNotes = notes.filter(note =>
    note.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const handleDownload = async (note) => {
    if (note.external) {
      window.open(note.drive, '_blank');
      return;
    }
    try {
      const fileUrl = `${process.env.REACT_APP_POCKETBASE_URL}/api/files/${note.collectionId}/${note.id}/${note.file}`;
      
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('target', '_blank'); 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading file:', error);
      alert('Failed to download file');
    }
  };

  const handlePreview = async (note) => {
    if (note.external) {
      window.open(note.drive, '_blank');
      return;
    }
    try {
      const filePreviewUrl = `${process.env.REACT_APP_POCKETBASE_URL}/api/files/${note.collectionId}/${note.id}/${note.file}`;
      setPreviewUrl(filePreviewUrl);
      setIsModalOpen(true);
    } catch (error) {
      console.error('Error fetching file preview:', error);
      alert('Failed to fetch file preview');
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setPreviewUrl('');
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  return (
    <Container>
      <Typography variant="h3" sx={{ 
        mb: 4,
        textAlign: "center",
        fontWeight: 700,
        color: "text.primary",
        letterSpacing: "-0.05rem",
        marginTop: "20px",
        "&:after": {
          content: '""',
          display: "block",
          width: "60px",
          height: "4px",
          backgroundColor: "primary.main",
          margin: "8px auto 0",
        }
      }}>
        Uni Notes
      </Typography>
            <div className="news-carousel h-32 overflow-hidden">
              <Slider {...settings}>
                {slides.map((news) => (
                  <div key={news.id} className="carousel-slide">
                    <img src={`${process.env.REACT_APP_POCKETBASE_URL}/api/files/${news.collectionId}/${news.id}/${news.image}`} alt={news.title} className="slide-image" />
                    <div className="slide-content">
                      <h3 className="slide-title text-white">{news.title}</h3>
                      <p className="slide-excerpt">{news.excerpt}</p>
                      
                    </div>
                  </div>
                ))}
            </Slider>
      </div>


      <SearchBar
        type="text"
        placeholder="Search notes..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      

      {isLoading ? (
        <LoadingMessage>Loading notes...</LoadingMessage>
      ) : error ? (
        <ErrorMessage>{error}</ErrorMessage>
      ) : (
        <NotesList>
          {filteredNotes.length === 0 ? (
            <EmptyMessage>No notes found{searchTerm && ` for "${searchTerm}"`}</EmptyMessage>
          ) : (
            filteredNotes.map(note => (
              <NoteItem key={note.id || note.file}>
                <NoteTitle>{note.name || 'Untitled Note'}</NoteTitle>
                <Icons>
                  <IconWrapper onClick={() => handlePreview(note)}>
                    <AiOutlineEye size={20} />
                  </IconWrapper>
                  <IconWrapper onClick={() => handleDownload(note)}>
                    <AiOutlineDownload size={20} />
                  </IconWrapper>
                </Icons>
              </NoteItem>
            ))
          )}
        </NotesList>
      )}

      {isModalOpen && (
        <Modal>
          <ModalContent>
            <CloseButton onClick={closeModal}>
              <AiOutlineClose size={24} />
            </CloseButton>
            <PreviewIframe 
              src={previewUrl} 
              title="Note Preview" 
              allow="autoplay"
            />
          </ModalContent>
        </Modal>
      )}
    </Container>
  );
};

export default NotesPage;

const Container = styled.div`
  padding: 10px;
  max-width: 600px;
  margin: 0 auto;
  min-height: 60vh;
`;

const SearchBar = styled.input`
  width: 100%;
  padding: 12px 16px;
  margin: 20px 0 20px 0;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s;

  &:focus {
    border-color: #2196f3;
    outline: none;
  }
`;

const NotesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const NoteItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px 5px 10px;
  border: 2px solid #eee;
  border-radius: 12px;
  background: #fff;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const NoteTitle = styled.span`
  font-size: 16px;
  color: #333;
  font-weight: 500;
`;

const Icons = styled.div`
  display: flex;
  gap: 16px;
`;

const IconWrapper = styled.div`
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.2s;
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }

  &:active {
    transform: scale(0.95);
  }
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  position: relative;
  width: 90%;
  height: 80%;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
  z-index: 1001;

  &:hover {
    background-color: #f0f0f0;
  }
`;

const PreviewIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 18px;
`;

const ErrorMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: #d32f2f;
  font-size: 18px;
`;

const EmptyMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
`;
